export enum TreatmentPlanGoalStatus {
  'Generalization' = 'Generalization',
  'In Progress' = 'In Progress',
  'Maintenance' = 'Maintenance',
  'Mastered' = 'Mastered',
  'New Goal' = 'New Goal',
  'On Hold' = 'On Hold',
  'Terminated / Discontinued' = 'Terminated / Discontinued',
}
